<div *ngIf="pov=='vendor'">
  <div class="row">
    <div class="col-12 mb-3">
      <div class="cd-title">
        <div class="row">
          <div class="col-8">{{title}}</div>
           <div class="col-4 text-end" *ngIf="quotation?.displayQuotationId"># {{formatDisplayId(quotation?.displayQuotationId)}}</div>
        </div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="container cd-content py-md-3 px-md-4">
        <div class="row align-items-center" >
          <div class="col-lg-7">
            <div class="cd-subtitle py-3" *ngIf="rfq?.procurementName">
              <font>Quotation Untuk: {{rfq.procurementName}}</font>
            </div>            
          </div>
          <div class="col-lg-5">
            <ng-container *ngIf="procurementState!=='preview'">
            <div class="d-flex flex-row-reverse" *ngIf="isDraft=='false'">
              <ng-container *ngIf="quotation?.id">
                <a class="cd-out-btn ms-3" href="/quotation/export/pdf/{{rfqIdParticipate}}/{{quotation?.id}}"><i class="bi bi-printer-fill"></i> Cetak Quotation</a>
              </ng-container>
              
              <a class="cd-out-btn2" (click)="sendMessage()"><i class="bi bi-chat-left-dots-fill"></i> Hubungi Pelanggan</a>
            </div>
            <div class="d-flex flex-row-reverse" *ngIf="isDraft!='false'">
              <font class="cd-out-btn ms-3"><i class="bi bi-printer-fill"></i> Cetak Quotation</font>
              <font class="cd-out-btn2"><i class="bi bi-chat-left-dots-fill"></i> Hubungi Pelanggan</font>
            </div>
            </ng-container>
          </div>
        </div>

        <div class="cd-rfq-header p-3 my-3">
          <div class="row">
            <div class="col-12">
              <h5>Permintaan Pelanggan</h5>
            </div>
            <div class="col-lg-4">
              <p class="mb-0"><b>Alamat Pengiriman</b></p>

              <!-- pasar rfq detail preview -->
               <ng-container *ngIf="rfq?.companyLocation">
                  <p class="mb-0">{{rfq.companyLocation.city}}</p>
                  <p>{{rfq.companyLocation.country}}</p>
               </ng-container>
               <ng-container *ngIf="!rfq?.companyLocation">
                  <p class="mb-0">{{rfq.rfqDeliveryStreet}}</p>
                  <p class="mb-0">{{rfq.rfqDeliveryCity}}</p>
                  <p class="mb-0">{{rfq.rfqDeliveryPostalCode}}</p>
                  <p class="mb-0">{{rfq.rfqDeliveryProvince}}</p>
                  <p>{{rfq.rfqDeliveryCountry}}</p>
               </ng-container>

            </div>
            <div class="col-lg-4">
              <p class="mb-0"><b>Kurs Mata Uang</b></p>
              <p>{{rfq.currency}}</p>

              <p class="mb-0"><b>Termin Pembayaran</b></p>
              <p>{{rfq.paymentTermRequestedInDays ?rfq.paymentTermRequestedInDays :'-' }} 
                <span *ngIf="rfq.paymentTermRequestedInDays">{{'days'|translate}}</span>
              </p>

            </div>
            <div class="col-lg-4">
              <p class="mb-0"><b>Permintaan ETA (Perkiraan Waktu Tiba)</b></p>
              <p *ngIf="rfq.etaRequested">{{rfq.etaRequested | date:'d MMM y'}}</p>
              <p *ngIf="!rfq.etaRequested">-</p>

              <p class="mb-0"><b>RFQ berlaku hingga</b></p>
              <p *ngIf="rfq.submitQuotationLastDate">{{rfq.submitQuotationLastDate | date:'d MMM y'}}</p>
              <p *ngIf="!rfq.submitQuotationLastDate">-</p>


              <p class="mb-0" *ngIf="rfq.isForFullQuote"><b class="text-success">Hanya Menerima Penawaran Lengkap</b></p>
              <p class="mb-0" *ngIf="rfq.isIndentAccepted"><b class="text-success">Menerima Pesanan Saat Stok Kosong (Inden)</b></p>

            </div>
          </div>
        </div>

        <div class="cd-quotation-header p-3 my-3" *ngIf="quotation">
          <div class="row">
            <div class="col-12">
              <h5>Penawaran Anda</h5>
            </div>
            <div class="col-lg-4">
              <p class="mb-0"><b>Alamat Pengiriman</b></p>
              <p class="mb-0">{{quotation?.quotationDeliveryCity}}</p>
              <p>{{quotation?.quotationDeliveryCountry}}</p>
            </div>
            <div class="col-lg-4">
              <p class="mb-0"><b>Nomor Referensi</b></p>
              <p>{{quotation?.vendorRefNumber ? quotation?.vendorRefNumber :'-' }}</p>

              <p class="mb-0"><b>Termin Pembayaran</b></p>
              <p>{{quotation?.paymentTermOfferedInDays ? quotation?.paymentTermOfferedInDays :'-' }} 
                <span *ngIf="quotation?.paymentTermOfferedInDays">{{'days'|translate}}</span>
              </p>

              <p class="mb-0"><b>Lainnya yang Disertakan</b></p>
              <p>{{quotation?.otherCost ? quotation?.otherCost :'-' }}</p>
            </div>
            <div class="col-lg-4">
              <p class="mb-0"><b>Tawaran ETA (Perkiraan Waktu Tiba)</b></p> 

              <div *ngIf="quotation?.etaOffered && isDraft=='true'">
                {{ quotation.etaOffered * 1000 | date: 'd MMM y' }}
              </div>
              <div *ngIf="quotation?.etaOffered && isDraft=='false'">
                <p *ngIf="quotation?.etaOffered">{{quotation?.etaOffered | date:'d MMM y'}}</p>
              </div>
              <p *ngIf="!quotation?.etaOffered">-</p>

              <div class="my-2">
              <p class="mb-0"><b>Auto-bid</b></p>
              <p *ngIf="!quotation?.isAutoBidActive">{{'no'|translate}}</p>
              <p *ngIf="quotation?.isAutoBidActive">
                {{'yes'|translate}} ( 
                  <font *ngIf="quotation?.maxNumberOfAutoBid">{{'max_autobid'|translate}} :&nbsp;</font> 
                  <font *ngIf="quotation?.maxNumberOfAutoBid<9999">{{quotation?.maxNumberOfAutoBid}}</font> 
                  <font *ngIf="quotation?.maxNumberOfAutoBid==9999">{{'unlimited'|translate}}</font> <!-- 9999 unlimited-->
                  <font *ngIf="!quotation?.maxNumberOfAutoBid">{{'unlimited'|translate}}</font> 
                )
              </p>
              </div>

              <p class="mb-0"><b class="text-success" *ngIf="quotation?.isForFullOrder">Hanya Menerima Pesanan Lengkap</b></p>
              <p class="mb-0"><b class="text-success" *ngIf="quotation?.isShippingCostIncluded">Termasuk Biaya Pengiriman</b></p>
            </div>
          </div>
        </div>

        <div class="option-title my-4">Daftar permintaan produk</div>

        <div class="cd-rfq-product">

          <ng-container  *ngFor="let product of products; let i = index">
            <div class="mb-3">
              <ngb-accordion [closeOthers]="true" activeIds="static-{{i}}">
                <ngb-panel id="static-{{i}}">

                  <ng-template ngbPanelHeader let-opened="opened">
                    <button ngbPanelToggle class="btn btn-link p-0 w-100 text-decoration-none">
                      <div class="d-flex align-items-center justify-content-between px-3 py-2 cd-rfq-product-title">
                        <div class="limit-div">
                          <p class="mb-0">
                            <b class="d-block limit-div pe-3">
                            {{(product.brand)? product.brand+" : ":""}}{{divDetailspec(product.description)}}
                            </b>

                          </p>
                        </div>

                        <a class="btn btn-link p-0">
                          <h4 class="mb-0 bi bi-chevron-{{ opened ? 'up' : 'down' }}"></h4>
                        </a>
                      </div>
                    </button>

                  </ng-template>

                  <ng-template ngbPanelContent>

                    <div class="cd-rfq-product-request p-3 mb-3">
                      <div class="row">

                        
                        <div class="col-lg-11 order-2 order-lg-1">
                          <div class="row">
                            <div class="col-lg-3 text-center px-3">

                              <lightgallery *ngIf="product?.fileName.length>0" [settings]="settingsGallery" id="previewGallery" [onInit]="onInitGallery" class="row g-0">


                                <a *ngFor="let img of product?.fileName; let i = index" class="text-center {{i==0?'col-12':'col-4'}}" [attr.href]="img">
                                  <div style="  display: flex;
                                  align-items: center;
                                  justify-content: space-between;">
                                    <i *ngIf="i==0 && product?.fileName.length>1" class="bi bi-chevron-left text-black-50" style="
                                        position: absolute;
                                    "></i>
                                    <div class="text-center w-100 cd-image-container">
                                      <img *ngIf="i==0" class="img-fluid p-1" [src]="img" onError="this.src='/assets/images/notfound.png'" />
                                    </div>
                                    <i *ngIf="i==0 && product?.fileName.length>1" class="bi bi-chevron-right text-black-50" style="
                                        position: relative;
                                        right: 15px;
                                    "></i>
                                  </div>

                                </a>

                              </lightgallery>
                              <div class="cd-image-container" *ngIf="product?.fileName.length==0">
                                <img  class="img-fluid p-1" src="/assets/images/notfound.png"  />
                              </div>
                              
                              
                              
                            </div>
                            <div class="col-lg-4">

                              <p class="mb-0"><b>Merek Produk</b></p>
                              <p>{{product.brand?product.brand:'-'}}</p>

                              <p class="mb-0"><b>Nomor SKU</b></p>
                              <p>{{product.manufacturerSku?product.manufacturerSku:'-'}}</p>

                              <p class="mb-0"><b>Jumlah Diminta</b></p>
                              <p>{{product.qtyNeeded}} {{product.itemUnit}}</p>



                            </div>
                            <div class="col-lg-4">

                              <p class="mb-0"><b>Deskripsi Produk</b></p>
                              <div class="mb-2">
                                <font *ngIf="!(divDetailspecLess(product.description).length>50)">{{ divDetailspecLess(product.description) }}</font>

                                <div *ngIf="arrMoreLessDesc[i]=='less' && divDetailspecLess(product.description).length>50">
                                  {{ divDetailspecLess(product.description) }}
                                  <strong><span class="c1 pointer" (click)="MoreLessDesc(i,'more')">Read More</span></strong>
                                </div>
                                <div *ngIf="arrMoreLessDesc[i]=='more' && divDetailspecLess(product.description).length>50">
                                  {{ divDetailspec(product.description) }}
                                  <strong><span class="c1 pointer" (click)="MoreLessDesc(i,'less')">Read Less</span></strong>                   
                                </div>             
                              </div>

                              <p class="mb-0"><b>Label - Spesifikasi</b></p>
                              <div [innerHTML]="divspec(product.description)"></div>                          
                              <p *ngIf="!divspec(product.description)">-</p>
                             
                              
                            </div>                          
                          </div>

                        </div>

                        <div class="col-lg-1 text-end  order-1 order-lg-2" *ngIf="procurementState!=='preview'">
                            <app-share *ngIf="product.description" shareType="rfq" shareData="{{valshareData | json}}" shareDetail="{{product | json}}" shareTitle="{{product.description}}" shareUrl="{{currentUrl}}"></app-share>
                        </div>

                      </div>
                    </div>


                    <div class="{{(mappingProductWithOffer(product.id,'rfqItemId'))?'':'d-none' }}"  *ngIf="quotation">

                      <ng-container  *ngIf="mappingProductWithOffer(product.id,'rfqItemId')!=='-'">

                      <h6 class="mb-3 cd-quote-total"><b>Penawaran Anda</b></h6>

                      <div class="cd-rfq-product-quote p-3 mb-3">
                        <div class="row">
                          <div class="col-lg-3 text-center px-3">
                                  <lightgallery *ngIf="mappingProductWithOffer(product.id,'fileName')?.length>0" [settings]="settingsGallery" id="previewGallery" [onInit]="onInitGallery" class="row g-0">


                                    <a *ngFor="let img of mappingProductWithOffer(product.id,'fileName'); let i = index" class="text-center {{i==0?'col-12':'col-4'}}" [attr.href]="img">
                                      <div style="  display: flex;
                                      align-items: center;
                                      justify-content: space-between;">
                                        <i *ngIf="i==0 && mappingProductWithOffer(product.id,'fileName')?.length>1" class="bi bi-chevron-left text-black-50" style="
                                            position: absolute;
                                        "></i>
                                        <div class="text-center w-100 cd-image-container">
                                          <img *ngIf="i==0" class="img-fluid p-1" [src]="img" onError="this.src='/assets/images/notfound.png'" />
                                        </div>
                                        <i *ngIf="i==0 && mappingProductWithOffer(product.id,'fileName')?.length>1" class="bi bi-chevron-right text-black-50" style="
                                            position: relative;
                                            right: 15px;
                                        "></i>
                                      </div>

                                    </a>

                                  </lightgallery>
                                  <div class="cd-image-container" *ngIf="mappingProductWithOffer(product.id,'fileName')?.length==0">
                                      <img  class="img-fluid p-1" src="/assets/images/notfound.png"  />
                                  </div>
                                  
                          </div>
                          <div class="col-lg-3">
                              <p class="mb-0"><b>Nama Produk</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'productNameOffered') }}</p>

                              <p class="mb-0"><b>Merek Produk</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'productBrandOffered') }}</p>
                               
                              <p class="mb-0"><b>Nomor SKU</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'productManufacturerCodeOffered') }}</p>                              
                          </div>
                          <div class="col-lg-3">
                              <p class="mb-0"><b>Harga Produk</b></p>
                              <p>
                                {{rfq.currency}} {{ mappingProductWithOffer(product.id,'priceOffered') | number }}
                                      <span *ngIf="compareProductPrice(product.id,'productPrice') " class="badge rounded-pill bg-success" style="font-size: 9px;">price update</span>
                              </p>

                              <p class="mb-0"><b>Jumlah Ditawarkan</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'qtyOffered') }} {{product.itemUnit}}</p>
                               
                              <p class="mb-0"><b>Total Harga Ditawarkan</b></p>
                              <p>
                                {{rfq.currency}} 
                                {{ mappingProductWithOffer(product.id,'qtyOffered') * mappingProductWithOffer(product.id,'priceOffered') | number }}
                              </p>  
                          </div>
                          <div class="col-lg-3">
                              <p class="mb-0"><b>Deskripsi Produk</b></p>
                              <div class="mb-2">
                                    <font *ngIf="!(divDetailspecLess(arrDescOffer[product.id])?.length>50)">{{ divDetailspecLess(arrDescOffer[product.id]) }}</font>
        
                                      <div *ngIf="arrMoreLessDescOffer[i]=='less' && divDetailspecLess(arrDescOffer[product.id])?.length>50">
                                        {{ divDetailspecLess(arrDescOffer[product.id]) }}
                                        <strong><span class="c1 pointer" (click)="MoreLessDescOffer(i,'more')">Read More</span></strong>
                                      </div>
                                      <div *ngIf="arrMoreLessDescOffer[i]=='more' && divDetailspecLess(arrDescOffer[product.id])?.length>50">
                                        {{ divDetailspec(arrDescOffer[product.id]) }}
                                        <strong><span class="c1 pointer" (click)="MoreLessDescOffer(i,'less')">Read Less</span></strong>                   
                                      </div>
                                                                                   
                              </div>

                              <p class="mb-0"><b>Label - Spesifikasi</b></p>
                              <div [innerHTML]="mappingProductWithOffer(product.id,'productDescOfferedSpec')"></div>
                              <p *ngIf="!mappingProductWithOffer(product.id,'productDescOfferedSpec')">-</p> 
                          </div>


                        </div>
                      </div>                  

                      <div class="w-100">
                            <div class="row pb-3 pb-md-2 pb-lg-2" *ngIf="QuotationState=='PUBLISHED'">
                              <div class="col-lg-9 col-md-7 col-sm-12"></div>
                              <div class="col-lg-3 col-md-5 col-sm-12 text-center" *ngIf="mappingProductWithOffer(product.id,'rfqItemId')">

                                <a *ngIf="!btnLoading" class="btn btn-primary fhbcyan rounded-1 roundedmore mb-2" (click)="ConfirmsubmitMarketLeader(mappingProductWithOffer(product.id,'id'),mappingProductWithOffer(product.id,'rfqItemId'))">
                                  <img src="/assets/images/icons/Market_inteligence-Add@3x.png" class="market-int-icon" style="    max-width: 150px;">
                                </a>
                                <a *ngIf="btnLoading" class="btn btn-primary fhbcyan rounded-1 roundedmore mb-2" style="opacity: 0.4;" disabled>
                                  <img src="/assets/images/icons/Market_inteligence-Add@3x.png" class="market-int-icon" style="    max-width: 150px;">
                                </a>

                                <br>
                                <div *ngIf="mappingProductWithOffer(product.id,'marketIntelligent')">
                                  <h6 class="mb-0 market-int-text" *ngIf="mappingProductWithmarketIntelligent(product.id,'isMarketLeader')">PRICE LEADER</h6>
                                  <h6 class="mb-0 market-int-text-not" *ngIf="!mappingProductWithmarketIntelligent(product.id,'isMarketLeader')">NOT PRICE LEADER</h6>
                                  <sup class=" market-int-small mt-1 p-0" *ngIf="mappingProductWithmarketIntelligent(product.id,'lastUsageDateTime')">{{mappingProductWithmarketIntelligent(product.id,'lastUsageDateTime') | date: 'dd-MMM-yyyy HH:mm:ss'}}</sup>
                                </div>

                                <sup><i class="ps-2 bi bi-info-circle pointer" placement="top auto" ngbTooltip="{{'rfq.market_int' | translate}}"  container="body" triggers="click" [autoClose]="'outside'"></i></sup>
                              </div>
                            </div>
                      </div>
                      <div class="d-flex flex-row-reverse">
                        <div class="text-center">




                        </div>
                      </div>

                      </ng-container>
                    </div>


                  </ng-template>
                </ngb-panel>
              </ngb-accordion>
            </div>
          </ng-container>




        </div>

        <div class="cd-content"  *ngIf="quotation">

                    <div class="row g-0">
                      <div class="col-12 col-sm-12 col-md-6 col-lg-8 cd-quote-memo">
                        <p class="mb-2"><b>Memo Penawaran untuk Pelanggan</b></p>
                        <p>{{ quotation?.memo ?  quotation?.memo :'-'}}</p>
                      </div>
                      
                      <div class="col-6 col-sm-6 col-md-3 col-lg-2 cd-quote-total"  *ngIf="!quotation?.isTaxIncluded">
                        <p class="mb-0">Subtotal</p>

                        <p *ngIf="quotation?.taxValue">Tax</p>
                        <p *ngIf="quotation?.taxPercentage">Tax({{quotation?.taxPercentage}}%)</p>

                        <p><b>Total</b></p>
                      </div>
                      <div class="col-6 col-sm-6 col-md-3 col-lg-2  cd-quote-total"  *ngIf="quotation?.isTaxIncluded">
                        <p><b>Total</b></p>
                      </div>

                      <div class="col-6 col-sm-6 col-md-3 col-lg-2  text-end  cd-quote-total" *ngIf="!quotation?.isTaxIncluded">
                        <p class="mb-0">{{rfq.currency}} {{ totalQuotationPrice | number }}</p>

                        <p *ngIf="quotation?.taxValue">{{rfq.currency}} {{quotation?.taxValue | number}}</p>
                        <p *ngIf="quotation?.taxPercentage">{{rfq.currency}} {{ totalQuotationPrice  * quotation?.taxPercentage /100 | number }}</p>

                        <p><b>
                          {{rfq.currency}} {{ (quotation?.taxValue) ? transformDecimal(totalQuotationPrice +  quotation?.taxValue) : totalQuotationPrice + (totalQuotationPrice * quotation?.taxPercentage /100) | number }}
                        </b></p>
                      </div>
                      <div class="col-6 col-sm-6 col-md-3 col-lg-2 text-end cd-quote-total" *ngIf="quotation?.isTaxIncluded">
                        <p><b>
                          {{rfq.currency}} {{ totalQuotationPrice | number }}
                        </b></p>
                      </div>
                    </div>


        </div>
      </div>
    </div>
  </div>

</div>


<div *ngIf="pov=='procurement'" class="isProc">
  <div class="row">
    <div class="col-12 mb-3">
      <div class="cd-title">
        <div class="row">
          <div class="col-8">{{title}}</div>
           <div class="col-4 text-end" *ngIf="quotation?.displayQuotationId"># {{formatDisplayId(quotation?.displayQuotationId)}}</div>
        </div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="container cd-content py-md-3 px-md-4">

        <div class="tableqrfq  my-3">
          <div class="row">

            <div class="col-lg-4">
              <p class="mb-0"><b>Alamat Pengiriman</b></p>

              <!-- pasar rfq detail preview -->
               <ng-container *ngIf="rfq?.companyLocation">
                  <p class="mb-0">{{rfq.companyLocation.city}}</p>
                  <p>{{rfq.companyLocation.country}}</p>
               </ng-container>
               <ng-container *ngIf="!rfq?.companyLocation">
                  <p class="mb-0">{{rfq.rfqDeliveryStreet}}</p>
                  <p class="mb-0">{{rfq.rfqDeliveryCity}}</p>
                  <p class="mb-0">{{rfq.rfqDeliveryPostalCode}}</p>
                  <p class="mb-0">{{rfq.rfqDeliveryProvince}}</p>
                  <p>{{rfq.rfqDeliveryCountry}}</p>
               </ng-container>

            </div>
            <div class="col-lg-4">
              <p class="mb-0"><b>Kurs Mata Uang</b></p>
              <p>{{rfq.currency}}</p>

              <p class="mb-0"><b>Termin Pembayaran</b></p>
              <p>{{rfq.paymentTermRequestedInDays ?rfq.paymentTermRequestedInDays :'-' }} 
                <span *ngIf="rfq.paymentTermRequestedInDays">{{'days'|translate}}</span>
              </p>

            </div>
            <div class="col-lg-4">
              <p class="mb-0"><b>Permintaan ETA (Perkiraan Waktu Tiba)</b></p>
              <p *ngIf="rfq.etaRequested">{{rfq.etaRequested | date:'d MMM y'}}</p>
              <p *ngIf="!rfq.etaRequested">-</p>

              <p class="mb-0"><b>RFQ berlaku hingga</b></p>
              <p *ngIf="rfq.submitQuotationLastDate">{{rfq.submitQuotationLastDate | date:'d MMM y'}}</p>
              <p *ngIf="!rfq.submitQuotationLastDate">-</p>


              <p class="mb-0" *ngIf="rfq.isForFullQuote"><b class="text-success">Hanya Menerima Penawaran Lengkap</b></p>
              <p class="mb-0" *ngIf="rfq.isIndentAccepted"><b class="text-success">Menerima Pesanan Saat Stok Kosong (Inden)</b></p>

            </div>
          </div>
        </div>

        <div class="cd-quotation-header p-3 my-3" *ngIf="quotation">

          <div class="row">

            <div class="col-lg-4">
              <p class="mb-0"><b>Alamat Pengiriman</b></p>
              <p class="mb-0">{{quotation?.deliveryCity}}</p>
              <p>{{quotation?.deliveryCountry}}</p>
            </div>
            <div class="col-lg-4">
              <p class="mb-0"><b>Nomor Referensi</b></p>
              <p>{{quotation?.vendorRefNumber ? quotation?.vendorRefNumber :'-' }}</p>

              <p class="mb-0"><b>Termin Pembayaran</b></p>
              <p>{{quotation?.paymentTermOfferedInDays ? quotation?.paymentTermOfferedInDays :'-' }} 
                <span *ngIf="quotation?.paymentTermOfferedInDays">{{'days'|translate}}</span>
              </p>

              <p class="mb-0"><b>Lainnya yang Disertakan</b></p>
              <p>{{quotation?.otherCost ? quotation?.otherCost :'-' }}</p>
            </div>
            <div class="col-lg-4">
              <p class="mb-0"><b>Tawaran ETA (Perkiraan Waktu Tiba)</b></p> 

              <div *ngIf="quotation?.etaOffered && isDraft=='true'">
                {{ quotation.etaOffered * 1000 | date: 'd MMM y' }}
              </div>
              <div *ngIf="quotation?.etaOffered && isDraft=='false'">
                <p *ngIf="quotation?.etaOffered">{{quotation?.etaOffered | date:'d MMM y'}}</p>
              </div>
              <p *ngIf="!quotation?.etaOffered">-</p>



              <p class="mb-0"><b class="text-success" *ngIf="quotation?.isForFullOrder">Hanya Menerima Pesanan Lengkap</b></p>
              <p class="mb-0"><b class="text-success" *ngIf="quotation?.isShippingCostIncluded">Termasuk Biaya Pengiriman</b></p>
            </div>
          </div>
        </div>

        <div class="option-title my-4">Daftar permintaan produk</div>

        <div class="cd-rfq-product">
          <ng-container  *ngFor="let product of products; let i = index">

            <div class="mb-3">
              <ngb-accordion [closeOthers]="true" activeIds="static-{{i}}">
                <ngb-panel id="static-{{i}}">

                  <ng-template ngbPanelHeader let-opened="opened">
                    <button ngbPanelToggle class="btn btn-link p-0 w-100 text-decoration-none">
                      <div class="d-flex align-items-center justify-content-between px-3 py-2 cd-rfq-product-title">
                        <div class="limit-div">
                          <p class="mb-0">
                            <b class="d-block limit-div pe-3">
                            {{(product.brand)? product.brand+" : ":""}}{{divDetailspec(product.description)}}
                            </b>

                          </p>
                        </div>

                        <a class="btn btn-link p-0">
                          <h4 class="mb-0 bi bi-chevron-{{ opened ? 'up' : 'down' }}"></h4>
                        </a>
                      </div>
                    </button>

                  </ng-template>

                  <ng-template ngbPanelContent>

                    <div class="cd-rfq-product-request p-3 mb-3">
                      <div class="row">

                        
                        <div class="col-lg-11 order-2 order-lg-1">
                          <div class="row">
                            <div class="col-lg-3 text-center px-3">

                              <lightgallery *ngIf="product?.fileName.length>0" [settings]="settingsGallery" id="previewGallery" [onInit]="onInitGallery" class="row g-0">


                                <a *ngFor="let img of product?.fileName; let i = index" class="text-center {{i==0?'col-12':'col-4'}}" [attr.href]="img">
                                  <div style="  display: flex;
                                  align-items: center;
                                  justify-content: space-between;">
                                    <i *ngIf="i==0 && product?.fileName.length>1" class="bi bi-chevron-left text-black-50" style="
                                        position: absolute;
                                    "></i>
                                    <div class="text-center w-100 cd-image-container">
                                      <img *ngIf="i==0" class="img-fluid p-1" [src]="img" onError="this.src='/assets/images/notfound.png'" />
                                    </div>
                                    <i *ngIf="i==0 && product?.fileName.length>1" class="bi bi-chevron-right text-black-50" style="
                                        position: relative;
                                        right: 15px;
                                    "></i>
                                  </div>

                                </a>

                              </lightgallery>
                              <div class="cd-image-container" *ngIf="product?.fileName.length==0">
                                <img  class="img-fluid p-1" src="/assets/images/notfound.png"  />
                              </div>
                              
                              
                              
                            </div>
                            <div class="col-lg-4">

                              <p class="mb-0"><b>Merek Produk</b></p>
                              <p>{{product.brand?product.brand:'-'}}</p>

                              <p class="mb-0"><b>Nomor SKU</b></p>
                              <p>{{product.manufacturerSku?product.manufacturerSku:'-'}}</p>

                              <p class="mb-0"><b>Jumlah Diminta</b></p>
                              <p>{{product.qtyNeeded}} {{product.itemUnit}}</p>



                            </div>
                            <div class="col-lg-4">

                              <p class="mb-0"><b>Deskripsi Produk</b></p>
                              <div class="mb-2">
                                <font *ngIf="!(divDetailspecLess(product.description).length>50)">{{ divDetailspecLess(product.description) }}</font>

                                <div *ngIf="arrMoreLessDesc[i]=='less' && divDetailspecLess(product.description).length>50">
                                  {{ divDetailspecLess(product.description) }}
                                  <strong><span class="c1 pointer" (click)="MoreLessDesc(i,'more')">Read More</span></strong>
                                </div>
                                <div *ngIf="arrMoreLessDesc[i]=='more' && divDetailspecLess(product.description).length>50">
                                  {{ divDetailspec(product.description) }}
                                  <strong><span class="c1 pointer" (click)="MoreLessDesc(i,'less')">Read Less</span></strong>                   
                                </div>             
                              </div>

                              <p class="mb-0"><b>Label - Spesifikasi</b></p>
                              <div [innerHTML]="divspec(product.description)"></div>                          
                              <p *ngIf="!divspec(product.description)">-</p>
                             
                              
                            </div>                          
                          </div>

                        </div>

                        <div class="col-lg-1 text-end  order-1 order-lg-2" *ngIf="procurementState!=='preview'">
                            <app-share *ngIf="product.description" shareType="rfq" shareData="{{valshareData | json}}" shareDetail="{{product | json}}" shareTitle="{{product.description}}" shareUrl="{{currentUrl}}"></app-share>
                        </div>

                      </div>
                    </div>


                    <div class="{{(mappingProductWithOffer(product.id,'rfqItemId'))?'':'d-none' }}"  *ngIf="quotation">
                      <!-- <h6 class="mb-3 cd-quote-total"><b>Penawaran Anda</b></h6> -->

                      <div class="cd-rfq-product-quote p-3 mb-3" *ngIf="mappingProductWithOffer(product.id,'rfqItemId')!=='-'">
                        <div class="row">
                          <div class="col-lg-3 text-center px-3">
                                  <lightgallery *ngIf="mappingProductWithOffer(product.id,'fileName')?.length>0" [settings]="settingsGallery" id="previewGallery" [onInit]="onInitGallery" class="row g-0">


                                    <a *ngFor="let img of mappingProductWithOffer(product.id,'fileName'); let i = index" class="text-center {{i==0?'col-12':'col-4'}}" [attr.href]="img">
                                      <div style="  display: flex;
                                      align-items: center;
                                      justify-content: space-between;">
                                        <i *ngIf="i==0 && mappingProductWithOffer(product.id,'fileName')?.length>1" class="bi bi-chevron-left text-black-50" style="
                                            position: absolute;
                                        "></i>
                                        <div class="text-center w-100 cd-image-container">
                                          <img *ngIf="i==0" class="img-fluid p-1" [src]="img" onError="this.src='/assets/images/notfound.png'" />
                                        </div>
                                        <i *ngIf="i==0 && mappingProductWithOffer(product.id,'fileName')?.length>1" class="bi bi-chevron-right text-black-50" style="
                                            position: relative;
                                            right: 15px;
                                        "></i>
                                      </div>

                                    </a>

                                  </lightgallery>
                                  <div class="cd-image-container" *ngIf="mappingProductWithOffer(product.id,'fileName')?.length==0">
                                      <img  class="img-fluid p-1" src="/assets/images/notfound.png"  />
                                  </div>
                                  
                          </div>
                          <div class="col-lg-3">
                              <p class="mb-0"><b>Nama Produk</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'offeredProductName') }}</p>

                              <p class="mb-0"><b>Merek Produk</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'offeredProductBrand') }}</p>
                               
                              <p class="mb-0"><b>Nomor SKU</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'offeredProductManufacturerCode') }}</p>                              
                          </div>
                          <div class="col-lg-3">
                              <p class="mb-0"><b>Harga Produk</b></p>
                              <p>
                                {{rfq.currency}} {{ mappingProductWithOffer(product.id,'priceOffered') | number }}
                                      <span *ngIf="compareProductPrice(product.id,'productPrice') " class="badge rounded-pill bg-success" style="font-size: 9px;">price update</span>
                              </p>

                              <p class="mb-0"><b>Jumlah Ditawarkan</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'qtyOffered') }} {{product.itemUnit}}</p>
                               
                              <p class="mb-0"><b>Total Harga Ditawarkan</b></p>
                              <p>
                                {{rfq.currency}} 
                                {{ mappingProductWithOffer(product.id,'qtyOffered') * mappingProductWithOffer(product.id,'priceOffered') | number }}
                              </p>  
                          </div>
                          <div class="col-lg-3">
                              <p class="mb-0"><b>Deskripsi Produk</b></p>
                              <div class="mb-2">
                                    <font *ngIf="!(divDetailspecLess(arrDescOffer[product.id])?.length>50)">{{ divDetailspecLess(arrDescOffer[product.id]) }}</font>
        
                                      <div *ngIf="arrMoreLessDescOffer[i]=='less' && divDetailspecLess(arrDescOffer[product.id])?.length>50">
                                        {{ divDetailspecLess(arrDescOffer[product.id]) }}
                                        <strong><span class="c1 pointer" (click)="MoreLessDescOffer(i,'more')">Read More</span></strong>
                                      </div>
                                      <div *ngIf="arrMoreLessDescOffer[i]=='more' && divDetailspecLess(arrDescOffer[product.id])?.length>50">
                                        {{ divDetailspec(arrDescOffer[product.id]) }}
                                        <strong><span class="c1 pointer" (click)="MoreLessDescOffer(i,'less')">Read Less</span></strong>                   
                                      </div>
                                                                                   
                              </div>

                              <p class="mb-0"><b>Label - Spesifikasi</b></p>
                              <div [innerHTML]="mappingProductWithOffer(product.id,'productDescOfferedSpec')"></div>
                              <p *ngIf="!mappingProductWithOffer(product.id,'productDescOfferedSpec')">-</p> 
                          </div>


                        </div>
                      </div>                  

                      <div class="w-100">
                            <div class="row pb-3 pb-md-2 pb-lg-2" *ngIf="QuotationState=='PUBLISHED'">
                              <div class="col-lg-9 col-md-7 col-sm-12"></div>
                              <div class="col-lg-3 col-md-5 col-sm-12 text-center" *ngIf="mappingProductWithOffer(product.id,'rfqItemId')">

                                <a *ngIf="!btnLoading" class="btn btn-primary fhbcyan rounded-1 roundedmore mb-2" (click)="ConfirmsubmitMarketLeader(mappingProductWithOffer(product.id,'id'),mappingProductWithOffer(product.id,'rfqItemId'))">
                                  <img src="/assets/images/icons/Market_inteligence-Add@3x.png" class="market-int-icon" style="    max-width: 150px;">
                                </a>
                                <a *ngIf="btnLoading" class="btn btn-primary fhbcyan rounded-1 roundedmore mb-2" style="opacity: 0.4;" disabled>
                                  <img src="/assets/images/icons/Market_inteligence-Add@3x.png" class="market-int-icon" style="    max-width: 150px;">
                                </a>

                                <br>
                                <div *ngIf="mappingProductWithOffer(product.id,'marketIntelligent')">
                                  <h6 class="mb-0 market-int-text" *ngIf="mappingProductWithmarketIntelligent(product.id,'isMarketLeader')">PRICE LEADER</h6>
                                  <h6 class="mb-0 market-int-text-not" *ngIf="!mappingProductWithmarketIntelligent(product.id,'isMarketLeader')">NOT PRICE LEADER</h6>
                                  <sup class=" market-int-small mt-1 p-0" *ngIf="mappingProductWithmarketIntelligent(product.id,'lastUsageDateTime')">{{mappingProductWithmarketIntelligent(product.id,'lastUsageDateTime') | date: 'dd-MMM-yyyy HH:mm:ss'}}</sup>
                                </div>

                                <sup><i class="ps-2 bi bi-info-circle pointer" placement="top auto" ngbTooltip="{{'rfq.market_int' | translate}}"  container="body" triggers="click" [autoClose]="'outside'"></i></sup>
                              </div>
                            </div>
                      </div>
                      <div class="d-flex flex-row-reverse">
                        <div class="text-center">




                        </div>
                      </div>

                    </div>


                  </ng-template>
                </ngb-panel>
              </ngb-accordion>
            </div>


            <!-- <div class="mb-3"   *ngIf="mappingProductWithOffer(product.id,'rfqItemId')!=='-'">
              <ngb-accordion [closeOthers]="true" activeIds="static-{{i}}">
                <ngb-panel id="static-{{i}}">

                  <ng-template ngbPanelHeader let-opened="opened">
                    <button ngbPanelToggle class="btn btn-link p-0 w-100 text-decoration-none">
                      <div class="d-flex align-items-center justify-content-between px-3 py-2 cd-rfq-product-title">
                        <div class="limit-div">
                          <p class="mb-0">
                            <b class="d-block limit-div pe-3">
                            {{(product.brand)? product.brand+" : ":""}}{{divDetailspec(product.description)}}
                            </b>

                          </p>
                        </div>

                        <a class="btn btn-link p-0">
                          <h4 class="mb-0 bi bi-chevron-{{ opened ? 'up' : 'down' }}"></h4>
                        </a>
                      </div>
                    </button>

                  </ng-template>

                  <ng-template ngbPanelContent>


                    <div class="{{(mappingProductWithOffer(product.id,'rfqItemId'))?'':'d-none' }}">
                      
                      <div class="cd-rfq-product-quote p-3 mb-3">
                        <div class="row">
                          <div class="col-lg-3 text-center px-3">
                                  <lightgallery *ngIf="mappingProductWithOffer(product.id,'fileName')?.length>0" [settings]="settingsGallery" id="previewGallery" [onInit]="onInitGallery" class="row g-0">


                                    <a *ngFor="let img of mappingProductWithOffer(product.id,'fileName'); let i = index" class="text-center {{i==0?'col-12':'col-4'}}" [attr.href]="img">
                                      <div style="  display: flex;
                                      align-items: center;
                                      justify-content: space-between;">
                                        <i *ngIf="i==0 && mappingProductWithOffer(product.id,'fileName')?.length>1" class="bi bi-chevron-left text-black-50" style="
                                            position: absolute;
                                        "></i>
                                        <div class="text-center w-100 cd-image-container">
                                          <img *ngIf="i==0" class="img-fluid p-1" [src]="img" onError="this.src='/assets/images/notfound.png'" />
                                        </div>
                                        <i *ngIf="i==0 && mappingProductWithOffer(product.id,'fileName')?.length>1" class="bi bi-chevron-right text-black-50" style="
                                            position: relative;
                                            right: 15px;
                                        "></i>
                                      </div>

                                    </a>

                                  </lightgallery>
                                  <div class="cd-image-container" *ngIf="mappingProductWithOffer(product.id,'fileName')?.length==0">
                                      <img  class="img-fluid p-1" src="/assets/images/notfound.png"  />
                                  </div>
                                  
                          </div>
                          <div class="col-lg-3">
                              <p class="mb-0"><b>Nama Produk</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'offeredProductName') }}</p>

                              <p class="mb-0"><b>Merek Produk</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'offeredProductBrand') }}</p>
                               
                              <p class="mb-0"><b>Nomor SKU</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'offeredProductManufacturerCode') }}</p>                              
                          </div>
                          <div class="col-lg-3">
                              <p class="mb-0"><b>Harga Produk</b></p>
                              <p>
                                {{rfq.currency}} {{ mappingProductWithOffer(product.id,'priceOffered') | number }}
                                      <span *ngIf="compareProductPrice(product.id,'productPrice') " class="badge rounded-pill bg-success" style="font-size: 9px;">price update</span>
                              </p>

                              <p class="mb-0"><b>Jumlah Ditawarkan</b></p>
                              <p>{{ mappingProductWithOffer(product.id,'qtyOffered') }} {{product.itemUnit}}</p>
                               
                              <p class="mb-0"><b>Total Harga Ditawarkan</b></p>
                              <p>
                                {{rfq.currency}} 
                                {{ mappingProductWithOffer(product.id,'qtyOffered') * mappingProductWithOffer(product.id,'priceOffered') | number }}
                              </p>  
                          </div>
                          <div class="col-lg-3">
                              <p class="mb-0"><b>Deskripsi Produk</b></p>
                              <div class="mb-2">
                                    <font *ngIf="!(divDetailspecLess(arrDescOffer[product.id])?.length>50)">{{ divDetailspecLess(arrDescOffer[product.id]) }}</font>
        
                                      <div *ngIf="arrMoreLessDescOffer[i]=='less' && divDetailspecLess(arrDescOffer[product.id])?.length>50">
                                        {{ divDetailspecLess(arrDescOffer[product.id]) }}
                                        <strong><span class="c1 pointer" (click)="MoreLessDescOffer(i,'more')">Read More</span></strong>
                                      </div>
                                      <div *ngIf="arrMoreLessDescOffer[i]=='more' && divDetailspecLess(arrDescOffer[product.id])?.length>50">
                                        {{ divDetailspec(arrDescOffer[product.id]) }}
                                        <strong><span class="c1 pointer" (click)="MoreLessDescOffer(i,'less')">Read Less</span></strong>                   
                                      </div>
                                                                                   
                              </div>

                              <p class="mb-0"><b>Label - Spesifikasi</b></p>
                              <div [innerHTML]="mappingProductWithOffer(product.id,'productDescOfferedSpec')"></div>
                              <p *ngIf="!mappingProductWithOffer(product.id,'productDescOfferedSpec')">-</p> 
                          </div>


                        </div>
                      </div>                  

                      <div class="w-100">
                            <div class="row pb-3 pb-md-2 pb-lg-2" *ngIf="QuotationState=='PUBLISHED'">
                              <div class="col-lg-9 col-md-7 col-sm-12"></div>
                              <div class="col-lg-3 col-md-5 col-sm-12 text-center" *ngIf="mappingProductWithOffer(product.id,'rfqItemId')">

                                <a *ngIf="!btnLoading" class="btn btn-primary fhbcyan rounded-1 roundedmore mb-2" (click)="ConfirmsubmitMarketLeader(mappingProductWithOffer(product.id,'id'),mappingProductWithOffer(product.id,'rfqItemId'))">
                                  <img src="/assets/images/icons/Market_inteligence-Add@3x.png" class="market-int-icon" style="    max-width: 150px;">
                                </a>
                                <a *ngIf="btnLoading" class="btn btn-primary fhbcyan rounded-1 roundedmore mb-2" style="opacity: 0.4;" disabled>
                                  <img src="/assets/images/icons/Market_inteligence-Add@3x.png" class="market-int-icon" style="    max-width: 150px;">
                                </a>

                                <br>
                                <div *ngIf="mappingProductWithOffer(product.id,'marketIntelligent')">
                                  <h6 class="mb-0 market-int-text" *ngIf="mappingProductWithmarketIntelligent(product.id,'isMarketLeader')">PRICE LEADER</h6>
                                  <h6 class="mb-0 market-int-text-not" *ngIf="!mappingProductWithmarketIntelligent(product.id,'isMarketLeader')">NOT PRICE LEADER</h6>
                                  <sup class=" market-int-small mt-1 p-0" *ngIf="mappingProductWithmarketIntelligent(product.id,'lastUsageDateTime')">{{mappingProductWithmarketIntelligent(product.id,'lastUsageDateTime') | date: 'dd-MMM-yyyy HH:mm:ss'}}</sup>
                                </div>

                                <sup><i class="ps-2 bi bi-info-circle pointer" placement="top auto" ngbTooltip="{{'rfq.market_int' | translate}}"  container="body" triggers="click" [autoClose]="'outside'"></i></sup>
                              </div>
                            </div>
                      </div>
                      <div class="d-flex flex-row-reverse">
                        <div class="text-center">




                        </div>
                      </div>

                    </div>


                  </ng-template>
                </ngb-panel>
              </ngb-accordion>
            </div> -->
          </ng-container>




        </div>

        <div class="cd-content"  *ngIf="quotation">

                    <div class="row g-0">
                      <div class="col-12 col-sm-12 col-md-6 col-lg-8 cd-quote-memo">
                        <p class="mb-2"><b>Memo Penawaran</b></p>
                        <p>{{ quotation?.memo ?  quotation?.memo :'-'}}</p>
                      </div>
                      
                      <div class="col-6 col-sm-6 col-md-3 col-lg-2 cd-quote-total"  *ngIf="!quotation?.isTaxIncluded">
                        <p class="mb-0">Subtotal</p>

                        <p *ngIf="quotation?.taxValue">Tax</p>
                        <p *ngIf="quotation?.taxPercentage">Tax({{quotation?.taxPercentage}}%)</p>

                        <p><b>Total</b></p>
                      </div>
                      <div class="col-6 col-sm-6 col-md-3 col-lg-2  cd-quote-total"  *ngIf="quotation?.isTaxIncluded">
                        <p><b>Total</b></p>
                      </div>

                      <div class="col-6 col-sm-6 col-md-3 col-lg-2  text-end  cd-quote-total" *ngIf="!quotation?.isTaxIncluded">
                        <p class="mb-0">{{rfq.currency}} {{ totalQuotationPrice | number }}</p>

                        <p *ngIf="quotation?.taxValue">{{rfq.currency}} {{quotation?.taxValue | number}}</p>
                        <p *ngIf="quotation?.taxPercentage">{{rfq.currency}} {{ totalQuotationPrice  * quotation?.taxPercentage /100 | number }}</p>

                        <p><b>
                          {{rfq.currency}} {{ (quotation?.taxValue) ? transformDecimal(totalQuotationPrice +  quotation?.taxValue) : totalQuotationPrice + (totalQuotationPrice * quotation?.taxPercentage /100) | number }}
                        </b></p>
                      </div>
                      <div class="col-6 col-sm-6 col-md-3 col-lg-2 text-end cd-quote-total" *ngIf="quotation?.isTaxIncluded">
                        <p><b>
                          {{rfq.currency}} {{ totalQuotationPrice | number }}
                        </b></p>
                      </div>
                    </div>


        </div>
      </div>
    </div>
  </div>

</div>